import React from "react";
import ExlyFileUpload from "repoV2/features/Common/modules/Form/modules/ExlyFileUpload/ExlyFileUpload";
import { IFileUploadQuestion } from "./FileUploadQuestion.interfaces";

/**
 * @dev File upload config (filepath and bucket name) should be discussed with <@ayush> and
 * <@mayankdgupta> before using this common file uploader
 */
const FileUploadQuestion = (props: IFileUploadQuestion) => {
    const {
        name,
        title,
        validator,
        onChange,
        onClear,
        generateUploadKey,
        classes,
        isRequired,
        handleFileUploadStart,
        handleFileUploadEnd,
        uploadTypeAccept,
    } = props;

    return (
        <div className={classes.container}>
            <div className={classes.questionInput}>
                {title}&nbsp;
                {!isRequired && (
                    <span className={classes.optionalQuestionInput}>
                        (Optional)
                    </span>
                )}
            </div>
            <ExlyFileUpload
                name={name}
                classes={{ helperText: classes.helperText }}
                onChange={onChange}
                registerOptions={{ validate: validator }}
                generateUploadKey={generateUploadKey}
                onClear={onClear}
                handleFileUploadStart={handleFileUploadStart}
                handleFileUploadEnd={handleFileUploadEnd}
                accept={uploadTypeAccept}
            />
        </div>
    );
};

export default FileUploadQuestion;
